import { createRoot } from 'react-dom/client';
import App from './App';
import './index.css';

try {
  const rootElement = document.getElementById('root');
  if (!rootElement) throw new Error('Failed to find the root element');

  createRoot(rootElement).render(<App />);
} catch (error) {
  console.error('Error rendering app:', error);
}